export default __webpack_public_path__ + "static/media/bg-presentation.e252d7fe.jpg";